import { render, staticRenderFns } from "./VendorStyle.vue?vue&type=template&id=daee518a&scoped=true"
import script from "./VendorStyle.vue?vue&type=script&lang=js"
export * from "./VendorStyle.vue?vue&type=script&lang=js"
import style0 from "./VendorStyle.vue?vue&type=style&index=0&id=daee518a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daee518a",
  null
  
)

export default component.exports